<template>
  <div>
    <div class="btn-bottom-margin">
      <reports-list />
    </div>
  </div>
</template>

<script>
import ReportsList from '../../dashboard/Components/dialogComponents/reportsDialogs/ReportsList.vue';
export default {
  name: 'ReportsPage',
  components: {
    'reports-list': ReportsList,
  },
  data: () => ({}),
};
</script>

<style scoped></style>
